import clsx from 'clsx';
import { CircleAlert, Info } from 'lucide-react';
import { ReactNode } from 'react';
import styles from './InlineNotification.module.css';

type InlineNotificationProps = {
  appearance: 'info' | 'error';
  children: ReactNode;
};

export const InlineNotification = ({ appearance = 'info', children }: InlineNotificationProps) => {
  return (
    <div className={clsx(styles.container, styles[appearance], `inline-notification-${appearance}`)}>
      <div aria-hidden="true">
        {appearance === 'error' ? (
          <CircleAlert fill="#FF3C12" stroke="#FFEBE7" size="1.5rem" />
        ) : (
          <Info size="1.5rem" />
        )}
      </div>
      <div>{children}</div>
    </div>
  );
};
